import { Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { SequencingComponent } from './components/sequencing/sequencing';
import { DocumentManagerComponent } from './components/document-manager/document-manager.component';
import { TruthManagement } from './components/truth-management/truth-management';
import { LoanValidation } from './components/loan-validation/loan-validation';
import { RunValidationDetails } from './components/run-validation-details/run-validation-details';
import { EvaluationRuns } from './components/evaluation-runs/evaluation-runs';
import { BlankPageComponent } from './components/blank-page/blank-page.component';
import { DataExtraction } from './components/data-extraction/data-extraction';
import { DataExtractionPageComponent } from './components/data-extraction-page/data-extraction-page';
import { DataExtractionResultComponent } from './components/data-extraction-result/data-extraction-result';
import { InferenceResults } from './components/inference-results/inference-results';
import { VersioningComponent } from './components/versioning/versioning.component';
import { LoginComponent } from './components/login/login.component';
import { PromptTuningComponent } from './components/prompt-tuning/prompt-tuning';
import { AdminSettingsComponent } from './components/admin-settings/admin-settings';
import { StatsDashboardComponent } from './components/stats-dashboard/stats-dashboard.component';
import { DashboardLandingComponent } from './components/dashboard-landing/dashboard-landing.component';
import { OperationsRequestAnalyticsComponent } from './components/operations-request-analytics/operations-request-analytics.component';
import { IndexingComponent } from './components/indexing/indexing.component';
import { ExtractionReportsComponent } from './components/extraction-reports/extraction-reports.component';
import { SourceComponent } from './components/source/source.component';
import { EditDocumentModel } from './components/edit-document-model/edit-document-model';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';
import { AdminGuard } from './guards/admin.guard';

export const routes: Routes = [
  // Public routes - redirect root to new first dashboard page
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  
  // MSAL redirect handler - required for redirect flow
  { path: 'auth', component: MsalRedirectComponent },
  { path: 'docs/oauth2-redirect', component: MsalRedirectComponent },
  
  // Protected routes (require authentication)
  { path: 'document-manager', component: DocumentManagerComponent, canActivate: [MsalGuard] },
  { 
    path: 'truth-management', 
    component: TruthManagement, 
    canActivate: [MsalGuard],
    canDeactivate: [CanDeactivateGuard] // Prevent data loss on navigation
  },
  { 
    path: 'truth-management/:documentId/:fileId', 
    component: TruthManagement, 
    canActivate: [MsalGuard],
    canDeactivate: [CanDeactivateGuard] // Prevent data loss on navigation
  },
  { path: 'home', component: DashboardLandingComponent, canActivate: [MsalGuard] },
  { path: 'home-dashboard', redirectTo: '/home', pathMatch: 'full' },
  { path: 'dashboard', component: LoanValidation, runGuardsAndResolvers: 'always', canActivate: [MsalGuard] },
  { 
    path: 'admin-settings', 
    component: AdminSettingsComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'edit-document-model/:documentModel',
    component: EditDocumentModel, 
    canActivate: [MsalGuard],
    canDeactivate: [CanDeactivateGuard]
  },
  { 
    path: 'prompt-tuning/:documentModel', 
    component: PromptTuningComponent, 
    canActivate: [MsalGuard, AdminGuard],
    canDeactivate: [CanDeactivateGuard] // Prevent data loss on navigation
  },
  { path: 'evaluation-runs/:documentModel', component: EvaluationRuns, canActivate: [MsalGuard]},
  { path: 'run-validation/:loanId/:runId', component: RunValidationDetails, canActivate: [MsalGuard] },
  { path: 'run-validation/:loanId/:runId/:documentCode', component: RunValidationDetails, canActivate: [MsalGuard]  },
  { path: 'data-extraction', component: DataExtraction, canActivate: [MsalGuard] },
  { path: 'data_extraction', component: DataExtractionPageComponent, canActivate: [MsalGuard] },
  { path: 'data_extraction_result', component: DataExtractionResultComponent, canActivate: [MsalGuard] },
  { path: 'inference-results/:runId', component: InferenceResults, canActivate: [MsalGuard] },
  { path: 'versioning', component: VersioningComponent, canActivate: [MsalGuard] },
  { path: 'stats-dashboard', component: StatsDashboardComponent, canActivate: [MsalGuard] },
  { path: 'operations-request-analytics', component: OperationsRequestAnalyticsComponent, canActivate: [MsalGuard] },
  { path: 'indexing', component: IndexingComponent, canActivate: [MsalGuard] },
  { path: 'source', component: SourceComponent, canActivate: [MsalGuard] },
  { path: 'extraction-reports/:documentModel', component: ExtractionReportsComponent, canActivate: [MsalGuard] },
  { path: 'blank', component: BlankPageComponent }
];
